// Firebase 兼容型初始化插件
// 使用 firebase/compat 保持与旧版 API 的兼容性
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/analytics'
import 'firebase/compat/performance'

function isFn(fn) {
  return fn && typeof fn === 'function'
}

// 仅在客户端执行
if (process.client) {
  try {
    // 根据环境选择配置（使用项目现有的配置）
    const isProd = process.env.VUE_APP_ENV === 'prod'

    // TODO: 正式的还没账号先用测试的
    const firebaseConfig = isProd
      ? {
          apiKey: 'AIzaSyAzwj9jUlZLcrJTgBJIM2UhX4WX2ivLD70',
          authDomain: 'toplupe-dce37.firebaseapp.com',
          projectId: 'toplupe-dce37',
          storageBucket: 'toplupe-dce37.firebasestorage.app',
          messagingSenderId: '978475848336',
          appId: '1:978475848336:web:474a069fdaf672568abe15',
          measurementId: 'G-2DRV42MHH5',
        }
      : {
          apiKey: 'AIzaSyCrkP6Osz3RKdR9A3cg3r-0VFuMVBz8X6g',
          authDomain: 'toplupe-test-188aa.firebaseapp.com',
          projectId: 'toplupe-test-188aa',
          storageBucket: 'toplupe-test-188aa.firebasestorage.app',
          messagingSenderId: '256062533410',
          appId: '1:256062533410:web:2b41b26600dfc6ed0b7f7b',
          measurementId: 'G-S07ESQH2KT',
        }

    // 初始化 Firebase（兼容型 API，与旧版完全一致）
    if (!firebase.apps.length) {
      if (isFn(firebase.initializeApp)) {
        firebase.initializeApp(firebaseConfig)
      }
    } else {
      if (isFn(firebase.app)) {
        firebase.app()
      }
    }

    // 初始化 Analytics
    if (isFn(firebase.analytics)) {
      firebase.analytics()
    }
    // 设置 Performance 配置
    if (isFn(firebase.performance)) {
      firebase.performance()
    }

    // 将 firebase 挂载到 window 对象，保持向后兼容
    // 这样现有的 window.firebase 代码可以继续使用
    window.firebase = firebase
  } catch (e) {
    // eslint-disable-next-line
    console.error('Firebase initialization failed:', e)
  }
}
